var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarUnauthorized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 402.409,
    height: 230,
    viewBox: "0 0 402.409 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-14,.cls-16,.cls-20{fill:none}.cls-2{fill:#e7ebef}.cls-3{fill:#d3d7df}.cls-12,.cls-14,.cls-19,.cls-20,.cls-21{stroke-linecap:round}.cls-16{stroke-miterlimit:10}.cls-12,.cls-19,.cls-21,.cls-6{fill:#b9bfcc}.cls-8{fill:#fff}.cls-9{fill:#753bba}.cls-10{fill:#474e5e}.cls-11{fill:#88909f}.cls-12,.cls-19,.cls-21{stroke:#fff}.cls-12,.cls-14,.cls-19,.cls-20,.cls-21{stroke-linejoin:round}.cls-12{stroke-width:.76px}.cls-12,.cls-14{stroke-dasharray:18.18 1.01 1.01 2.02}.cls-14,.cls-20{stroke:#e7ebef}.cls-14{stroke-width:.51px}.cls-15{fill:#343a5c;opacity:.64}.cls-16{stroke:#474e5e;stroke-width:.46px}.cls-19{stroke-width:.99px;stroke-dasharray:23.88 1.33 1.33 2.65}.cls-20{stroke-width:.23px;stroke-dasharray:21.38 0 1.19 2.38}.cls-21{stroke-width:.15px;stroke-dasharray:3.65 .2 .2 .41}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5577",
    transform: "translate(4358.409 -15264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4604",
    fill: "none",
    d: "M0 0H400V230H0z",
    transform: "translate(-4356 15264)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-4358.41 15271.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20962",
    d: "M391.58 185.26c10.3-33.17 8.27-75.93-15.29-98.87C362.4 72.87 340.41 65.64 321 66c-23.51.43-41.54 15.61-51.31 17.1-32 4.91-47.5-15.95-53.29-20.82-5.17-4.33-54.71-51.53-85.6-59.1C82-8.78 43.93 14.25 18.54 51.1c-24.35 35.33-22.58 97-7 134.16z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4605",
    d: "M0 0H385.29V2H0z",
    className: "cls-3",
    transform: "translate(8.5 183.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20963",
    d: "M297.12 217.47l92.76-100",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4606",
    d: "M0 0H13.28V59.07H0z",
    className: "cls-3",
    transform: "translate(32.37 125.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4607",
    d: "M0 0H13.28V12.8H0z",
    className: "cls-3",
    transform: "translate(32.37 125.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4608",
    d: "M0 0H13.28V59.07H0z",
    className: "cls-3",
    transform: "translate(150.46 125.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4609",
    d: "M0 0H13.28V12.8H0z",
    className: "cls-3",
    transform: "translate(150.46 125.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4610",
    width: 153.54,
    height: 98.92,
    fill: "#eef2f5",
    stroke: "#b9bfcc",
    strokeDasharray: "37.8 1.51 1.51 3.02 9.07 0.76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "1.13px",
    rx: 7.14,
    transform: "translate(20.32 26.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4611",
    width: 153.54,
    height: 98.92,
    fill: "#eef2f5",
    stroke: "#d3d7df",
    strokeDasharray: "37.8 1.51 1.51 3.02 9.07 0.76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "1.13px",
    rx: 7.14,
    transform: "translate(20.32 26.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20964",
    d: "M49.51 81.8l13.64-18.29h8.5V83.1H77V89h-5.35v7h-6.8v-7H49.51zm15.34-11.09L55.61 83.1h9.24z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20965",
    d: "M85.14 68.21a12.26 12.26 0 0 1 10.7-5.45 12.11 12.11 0 0 1 10.64 5.45c2.2 3.35 2.9 7.4 2.9 11.54s-.7 8.2-2.9 11.55a12.11 12.11 0 0 1-10.64 5.45 12.26 12.26 0 0 1-10.7-5.45c-2.2-3.35-2.85-7.4-2.85-11.55s.65-8.19 2.85-11.54zM90.94 88a5.42 5.42 0 0 0 4.9 2.65 5.27 5.27 0 0 0 4.84-2.65c1.3-2 1.8-4.85 1.8-8.25s-.5-6.29-1.8-8.24a5.27 5.27 0 0 0-4.84-2.65 5.42 5.42 0 0 0-4.9 2.65c-1.25 1.95-1.75 4.85-1.75 8.24s.5 6.3 1.75 8.25z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20966",
    d: "M122.72 96V74.26h-7.79v-4.65c4.74 0 8-2.7 8.69-6.1h5.95V96z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20967",
    d: "M34.94 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20968",
    d: "M51.18 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20969",
    d: "M67.43 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20970",
    d: "M83.68 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20971",
    d: "M99.13 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20972",
    d: "M115.38 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20973",
    d: "M34.94 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20974",
    d: "M67.43 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20975",
    d: "M83.68 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20976",
    d: "M99.13 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20977",
    d: "M115.38 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20978",
    d: "M131.62 120.06h-8.18l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20979",
    d: "M147.08 120.06h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20980",
    d: "M163.32 120.06h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20981",
    d: "M34.94 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20982",
    d: "M51.18 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20983",
    d: "M67.43 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20984",
    d: "M83.68 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20985",
    d: "M99.13 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20986",
    d: "M115.38 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20987",
    d: "M34.94 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20988",
    d: "M67.43 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20989",
    d: "M83.68 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20990",
    d: "M99.13 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20991",
    d: "M115.38 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20992",
    d: "M131.62 43.99h-8.18l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20993",
    d: "M147.08 43.99h-8.19l4.09-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20994",
    d: "M163.32 43.99h-8.19l4.1-9.38h8.19z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20995",
    d: "M146.2 189h-13.55l5.51-17a1.34 1.34 0 0 1 2.54 0z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4612",
    d: "M0 0H18.14V2.29H0z",
    className: "cls-3",
    transform: "translate(130.36 189.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20996",
    d: "M135.14 181.38h8.58l-.67-2.08h-7.24z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20997",
    d: "M133.61 186.07h11.64l-.68-2.07h-10.28z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20998",
    d: "M285.84 208h-13.55l5.5-17a1.34 1.34 0 0 1 2.55 0z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4613",
    d: "M0 0H18.14V2.29H0z",
    className: "cls-3",
    transform: "translate(270 208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20999",
    d: "M274.77 200.35h8.59l-.68-2.07h-7.23z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21000",
    d: "M273.25 205.05h11.63l-.67-2.08h-10.29z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21001",
    d: "M37.78 207.34H24.23l5.5-17a1.34 1.34 0 0 1 2.54 0z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4614",
    d: "M0 0H18.14V2.29H0z",
    className: "cls-3",
    transform: "translate(21.93 207.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21002",
    d: "M26.71 199.69h8.59l-.68-2.08h-7.23z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21003",
    d: "M25.19 204.38h11.63l-.67-2.07H25.86z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21004",
    d: "M182.71 189h-13.55l5.5-17a1.34 1.34 0 0 1 2.55 0z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4615",
    d: "M0 0H18.14V2.29H0z",
    className: "cls-3",
    transform: "translate(166.87 189.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21005",
    d: "M171.64 181.38h8.59l-.68-2.08h-7.23z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21006",
    d: "M170.12 186.07h11.63l-.67-2.07h-10.29z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4616",
    d: "M0 0H1.94V29.42H0z",
    className: "cls-3",
    transform: "translate(54.31 153.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4617",
    d: "M0 0H6.34V1.41H0z",
    className: "cls-3",
    transform: "translate(52.1 182.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21007",
    fill: "#eef2f5",
    stroke: "#d3d7df",
    strokeDasharray: "17.16 0.69 0.69 1.37 4.12 0.34",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M60.52 154.06a8.09 8.09 0 0 0 2.73-7.63 8.1 8.1 0 0 0-5.25-6.18 8.09 8.09 0 0 0-8 1.45 8.09 8.09 0 0 0-2.73 7.63 8.08 8.08 0 0 0 5.24 6.18 8.12 8.12 0 0 0 8.01-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21008",
    d: "M54 149.59v3.81h-2v-10.13h3.78a3.16 3.16 0 1 1 0 6.32zm1.57-1.71a1.46 1.46 0 1 0 0-2.9H54v2.9z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4618",
    d: "M0 0H16.33V1.34H0z",
    className: "cls-3",
    transform: "rotate(41.05 -165.291 136.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2531",
    cx: 12.63,
    cy: 12.63,
    r: 12.63,
    className: "cls-8",
    transform: "translate(144.38 133.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2532",
    cx: 12.63,
    cy: 12.63,
    r: 12.63,
    className: "cls-8",
    transform: "translate(71.82 170.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    d: "M174.61 129.94l-1.43-.07-1-2.58.22-1.09a.68.68 0 0 0-.35-.74 19.4 19.4 0 0 0-7-2.16c-2.77-.28-5.6.5-11.16 2a88.142 88.142 0 0 0-15 5.45c-1.34.65-2.44 1.23-3.21 1.66a76.369 76.369 0 0 0-12.44-1 50.49 50.49 0 0 0-11.17.92c-4 .87-7.25 2.55-13.71 5.92a156.852 156.852 0 0 0-17.05 10.47l-1.45 1h-1.79a3.36 3.36 0 0 0-1.49.38h-.05l.92 1.23-7.45 4.98a6.249 6.249 0 0 0-1.26 1.09l-2.67 3 2.58-1-9.53 11a2.36 2.36 0 0 1-.63.5l-1.71.88a.34.34 0 0 0 0 .62l.66.31 1.26.77-.56.57c-.44.52-.43 1.08-.21 1.25s.49.06.79-.12l-.33 2.36a1.29 1.29 0 0 0 .43 1.14l.51.44 2.56 4.88-.13.14a.83.83 0 0 0-.15 1l.41.8-.14.25a.63.63 0 0 0 .24.85l.26.14 5.62-1.33a2.69 2.69 0 0 1 .85 0l2.54.29c.42 0-.91 3.72-.52 3.55l2.74-1.26a12.25 12.25 0 0 1 21.93-10.91c.12.24.23.47.33.7l52.16-23.91a12.25 12.25 0 1 1 19.81-14 12 12 0 0 1 1.29 4.32l1.52-.7a4.57 4.57 0 0 0 2.48-4.29l-.11-1.14 4.09-2.25-1.11-4.82a2 2 0 0 0-.56-1c-.29-.21-.63-.49-.83-.49z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21010",
    d: "M59.3 170.44l9.25-11.29.78-.12-8.01 9.81z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21011",
    d: "M74.87 159.29c.79-1.11 4.51-5.92 5.84-6.94 2.09-1.58 18.75-12.1 23.78-14.68 6-3.06 7.6-3.52 8.32-3.71 5.21-1.37 20.56.78 20.56.78-1 .51-15.29 7.47-26.06 12.27-12.57 5.61-12.46 5.61-16.18 7.19-5.19 2.22-9.61 4-12.89 5.3a21.709 21.709 0 0 1-3.12.27.31.31 0 0 1-.25-.48z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2533",
    cx: 10.75,
    cy: 10.75,
    r: 10.75,
    className: "cls-10",
    transform: "translate(73.94 172.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2534",
    cx: 5.06,
    cy: 5.06,
    r: 5.06,
    className: "cls-12",
    transform: "translate(79.72 178)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2535",
    cx: 10.75,
    cy: 10.75,
    r: 10.75,
    className: "cls-10",
    transform: "translate(146.47 135.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2536",
    cx: 5.06,
    cy: 5.06,
    r: 5.06,
    className: "cls-12",
    transform: "translate(152.25 140.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21012",
    d: "M133.37 134.74s-15.37-2.15-20.56-.74c-.72.19-2.34.65-8.32 3.71-4.64 2.38-19.17 11.51-23 14.16l-.94.65a61.75 61.75 0 0 0-5.67 6.79.31.31 0 0 0 .25.48 21.709 21.709 0 0 0 3.12-.27c1.57-.62 3.4-1.35 5.45-2.19l.44-4.19a2.39 2.39 0 0 1 1.08-1.76c5.72-3.77 10.55-6.92 14.39-9.47l4.56 6.53 3.15-1.41c.25-.1.49-.21.74-.33l-6.28-6.21a29.919 29.919 0 0 1 5.94-2.89 22.64 22.64 0 0 1 6.87-1.55 70.123 70.123 0 0 1 7.23.26l.92.05a.71.71 0 0 1 .64.59l.38 2.46c5.17-2.48 9.11-4.41 9.61-4.67z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21013",
    fill: "none",
    stroke: "#e7ebef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.25px",
    d: "M74.87 159.29c.79-1.11 4.51-5.92 5.84-6.94 2.09-1.58 18.75-12.1 23.78-14.68 6-3.06 7.6-3.52 8.32-3.71 5.21-1.37 20.56.78 20.56.78-1 .51-15.29 7.47-26.06 12.27-12.57 5.61-12.46 5.61-16.18 7.19-5.19 2.22-9.61 4-12.89 5.3a21.709 21.709 0 0 1-3.12.27.31.31 0 0 1-.25-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21014",
    d: "M82.05 158.31l-1.94 4.55 6.15 7.8",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21015",
    d: "M136.46 132.73l2.71.3 18.55-6.99 3.84-.27-4.01 4.91-.99 1.93",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21016",
    d: "M106.25 147.99l2.86 3.35 3.33 4.82 3.27 6.34 1.7 2.75 1.63 4.84",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21017",
    d: "M133.32 134.91l4 4.47.71 1.37 5.34 10.38 1.57 2.51.6 2.81",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21018",
    d: "M145.87 151H145l-36.66 15.42-10.75 6.7-1.75-1.58a11.12 11.12 0 0 0-6.47-2.81l-1.5-.13a18.88 18.88 0 0 0-12.42 3.4l-.31.22a17.61 17.61 0 0 0-6.73 9.19l-.21.68-6.66 2.5a.93.93 0 0 0 .07.59l.41.8-.14.25a.63.63 0 0 0 .21.83l5-1h.09l.9-.21a2.69 2.69 0 0 1 .85 0l2.54.29c.1 0 .1.23 0 .56l.81.11.64-.29a12.25 12.25 0 0 1 21.92-10.24l51.89-23.52c-.21-.42-.68-1.38-.86-1.76z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21019",
    d: "M73.8 188.68a12.53 12.53 0 0 1-1.07-2.94c-.26.09-4.28-.25-4.56-.27L62 187.06a.33.33 0 0 0-.25.44l.85 2.39a.59.59 0 0 0 .12.8l2.36 1.83a1.54 1.54 0 0 0 1.11.31l9.54-1 .28-.05a12.38 12.38 0 0 1-2.21-3.1z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21020",
    d: "M146.85 152.73l-37 15.54-14.94 8.08c.23.36.45.73.65 1.12a12.15 12.15 0 0 1 1.26 4l25-12.4 27.14-14a12.09 12.09 0 0 1-2.11-2.34z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21021",
    d: "M175.57 130.64l1.3 5.29-3.76 2.36s-.59 1.72-1.05 1.94L168.6 142a12.149 12.149 0 0 1 .59 2.76l.77-.39a3.771 3.771 0 0 0 .64-.43l6.57-5.28a1.85 1.85 0 0 0 .61-2l-1.42-4.7a3.1 3.1 0 0 0-.79-1.32z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21022",
    d: "M168.49 129.31v.09a61.668 61.668 0 0 0-9.16.92 63.391 63.391 0 0 0-15 4.57l-1.49 3.11q-3.85 1.23-7.76 2.58a373.863 373.863 0 0 0-42.83 17.77l-4 2.08a52.279 52.279 0 0 1 13.47 2.44 51.751 51.751 0 0 1 6.81 2.75l4.94-2 31-13.12 1.05-.37a12.25 12.25 0 0 1 22.31-10l.92-.42 4.11-2.12 2.19-1.13-1.36-6.46-1.31-2.73z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21023",
    d: "M159.33 128.06l1.78-2.06c.31-.18.65-.35 1-.51a13.11 13.11 0 0 1 5.5-1.16 1.42 1.42 0 0 1 1 .42l1 1-2.92 1.5a2.29 2.29 0 0 1-.76.22z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21024",
    d: "M56.68 172.41l.66.31 1.25.78-.55.57c-.44.52-.43 1.08-.22 1.25a.81.81 0 0 0 .79-.13l-.32 2.37a1.26 1.26 0 0 0 .43 1.14l.5.44 2.55 4.94-.14.13-.13.18 6.4-2.47c0-.41.13-.26.21-.68a23.78 23.78 0 0 1 4.69-9.94z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21025",
    d: "M131.77 132.73c.85.15 2.06.38 3.51.75l1.23-.64a.28.28 0 0 0-.16-.53l-.61.07-.13.08a76.371 76.371 0 0 0-12.44-1 61.239 61.239 0 0 0-7.81.36l-.37.58c.48-.06 1.23-.16 2.15-.25a53.51 53.51 0 0 1 14.63.58z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21026",
    d: "M57.62 174.67l.59-1.39 3.51-1.05a4.171 4.171 0 0 1 .87-.15l2.6-.13-1.54 2.44a2.07 2.07 0 0 1-2.08.93L59.7 175a2.47 2.47 0 0 0-.47 0l-1.34.08a.28.28 0 0 1-.27-.41z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21027",
    d: "M84.64 162.14h4a1.52 1.52 0 0 1 1.52 1.52h-7.04a1.52 1.52 0 0 1 1.52-1.52z",
    className: "cls-2",
    transform: "rotate(-27.25 86.54 162.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21028",
    d: "M112.28 149.62h4a1.52 1.52 0 0 1 1.52 1.52h-7.07a1.52 1.52 0 0 1 1.55-1.52z",
    className: "cls-2",
    transform: "rotate(-27.25 114.155 150.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21029",
    d: "M124.36 133.85h.64a4.55 4.55 0 0 1 4.55 4.55h-4.73a2.34 2.34 0 0 1-2.34-2.34v-.3a1.91 1.91 0 0 1 1.91-1.91z",
    className: "cls-2",
    transform: "rotate(-27.25 125.838 136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21030",
    d: "M252.92 153.74l20.02-37.09 1.24 1.8-19.1 34.85z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21031",
    d: "M390.08 138.64h2.12a1.15 1.15 0 0 1 1.15 1.09l1.47 7.66-4.74-1.83z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21032",
    d: "M305.52 108.64v71.25h45.73v-2.25l49.16-1.18v-18.32a6.32 6.32 0 0 0-1-3.4l-8.51-13.26v-1.2a3.9 3.9 0 0 0-3.16-3.74l-29.83-5.8-12.57-25.3a4.27 4.27 0 0 0-3.82-2.37H311.1a5.57 5.57 0 0 0-5.58 5.57z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4619",
    d: "M0 0H24.69V15.78H0z",
    className: "cls-10",
    transform: "translate(301.87 164.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21033",
    d: "M305.52 164.12v15.77l45.73.01v-2.25l49.16-1.18v-12.35z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4620",
    d: "M0 0H39.12V15.78H0z",
    className: "cls-10",
    transform: "translate(256.79 164.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4621",
    d: "M0 0H109.15V4.17H0z",
    className: "cls-10",
    transform: "translate(186.77 161.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4622",
    d: "M0 0H73.38V4.17H0z",
    className: "cls-10",
    transform: "translate(222.53 167.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4623",
    d: "M0 0H11.87V11.13H0z",
    className: "cls-10",
    transform: "translate(179.91 161.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4624",
    d: "M0 0H116.01V6.51H0z",
    className: "cls-9",
    transform: "translate(179.91 156.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4625",
    d: "M0 0H102.81V3.26H0z",
    className: "cls-6",
    transform: "translate(193.11 152.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21034",
    d: "M287.21 148.79h-16.29v-35h5.81a6.41 6.41 0 0 1 6.35 5.531z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21035",
    d: "M183.6 113.05l44.06 20.82 43.27 14.92 2.21-5.03-41.98-16.94-46.6-15.84z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21036",
    d: "M267.92 143.76h17.9a3.46 3.46 0 0 1 3.46 3.46v6.09h-21.36z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21037",
    d: "M182.21 129.89l3.2-17.65-.55-.49 19.21 6.76-.95-2.5a3.32 3.32 0 0 0-2.43-2.09l-10-2.15-8-4.3V111l-2.93 20.67 1.26.52a1.53 1.53 0 0 1 .95 1.42V135l-.21.42-.65 1.12a1.09 1.09 0 0 1-1.31.47l-1.76-.64-2.13 1.59 4.67 1.38a1 1 0 0 0 1-.29l2.7-3a2.28 2.28 0 0 0 .57-1.67l-.13-1.64a1.45 1.45 0 0 0-.49-1z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_65",
    d: "M0 0L83.14 5.66",
    className: "cls-16",
    transform: "translate(185.9 110.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21038",
    d: "M189.12 112.54l81.81 8.77v.94l-76.09-8.43 76.09 9.72",
    className: "cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21039",
    d: "M270.92 113.77l-9.61.39a1.3 1.3 0 0 0-.49 2.49l10.1 4.65z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4626",
    d: "M0 0H8.93V4.6H0z",
    className: "cls-6",
    transform: "translate(181.32 166.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21040",
    fill: "#343a5c",
    d: "M390.88 140.28a3.94 3.94 0 0 0-.64-2.05h-81.69v2.35h82.34z",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21041",
    fill: "none",
    stroke: "#e7ebef",
    strokeDasharray: "21.38 1.19 1.19 2.38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.59px",
    d: "M308.55 105.62v56h39.27s-.46-3.32.2-5a10.42 10.42 0 0 1 4.72-5v-20.15l-16-25.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21042",
    d: "M389.29 140.58h-80.74v21.05h39.27l48.48 2.49 2.18-8.05z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21043",
    d: "M310.78 107.41v22.85h37.24v-3.74l-13.26-19.11z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    d: "M0 0L44.81 0",
    className: "cls-10",
    transform: "translate(303.01 163.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21044",
    d: "M373 152.23a21.5 21.5 0 0 0-21.5 21.49 19.557 19.557 0 0 0 .35 3.85l42.64-3.68v-.17A21.49 21.49 0 0 0 373 152.23z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21045",
    d: "M339.82 107.41h6.39l11.67 23.33-3.57-.48z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21046",
    d: "M312.05 136.91h3.08V147h-3.08a1.5 1.5 0 0 1-1.5-1.5v-7.07a1.5 1.5 0 0 1 1.5-1.52z",
    className: "cls-2",
    transform: "rotate(180 312.84 141.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21047",
    d: "M395.75 162.18A24.66 24.66 0 0 0 350 179.89h1.24v-2.25l2.05-.05a20.81 20.81 0 1 1 41.4-3 13.531 13.531 0 0 1-.1 2l3.69-.09a24.54 24.54 0 0 0-2.53-14.32z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2537",
    cx: 16.59,
    cy: 16.59,
    r: 16.59,
    className: "cls-2",
    transform: "translate(357.23 160.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2538",
    cx: 14.12,
    cy: 14.12,
    r: 14.12,
    className: "cls-10",
    transform: "translate(359.97 162.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2539",
    cx: 6.65,
    cy: 6.65,
    r: 6.65,
    className: "cls-19",
    transform: "translate(367.56 169.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21048",
    d: "M399.22 176.49l-5.45.14-2.73-12.74h8.23z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21049",
    d: "M348.82 162.87l-.16 17.03h2.11l1.03-16.7z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21050",
    d: "M312.67 109.72v20.54h33.46v-3.36l-11.92-17.18z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    d: "M334.21 109.72h-21.54v20.54h33.46v-3.36z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21052",
    d: "M341.49 109.11h5.57l10.16 20.3-3.11-.42z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    d: "M339.82 107.41h6.39l11.67 23.33-3.57-.48z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    d: "M345.61 124.49a7.67 7.67 0 0 0-2.1 1.82 7.83 7.83 0 0 0-1.62 3.95h5.75l-.44-3.87z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21055",
    d: "M310.78 107.41v22.85h37.24v-3.74l-13.26-19.11z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2540",
    cx: 16.59,
    cy: 16.59,
    r: 16.59,
    className: "cls-2",
    transform: "translate(193.11 160.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2541",
    cx: 14.12,
    cy: 14.12,
    r: 14.12,
    className: "cls-10",
    transform: "translate(195.86 162.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2542",
    cx: 6.65,
    cy: 6.65,
    r: 6.65,
    className: "cls-19",
    transform: "translate(203.44 169.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2543",
    cx: 1.02,
    cy: 1.02,
    r: 1.02,
    className: "cls-21",
    transform: "translate(261.27 114.62)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544",
    cx: 1.02,
    cy: 1.02,
    r: 1.02,
    className: "cls-21",
    transform: "translate(199.08 115.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21056",
    d: "M344.58 107h4.85a1.26 1.26 0 0 1 1.26 1.26v10.93a1.26 1.26 0 0 1-1.26 1.26h-4.85z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    fill: "none",
    stroke: "#474e5e",
    strokeMiterlimit: 10,
    strokeWidth: "0.91px",
    d: "M348.49 119.13v8.25h-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4627",
    d: "M0 0H5.95V82.81H0z",
    className: "cls-10",
    transform: "translate(295.92 95.95)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarUnauthorized);
export default __webpack_public_path__ + "static/media/car-unauthorized.6021f02a71e7cc4df6d439f525106fe1.svg";
export { ForwardRef as ReactComponent };